<template>
    <section class="tables landing-page">
        <div>
            <b-modal ref="modalRef" id="modal-1" title="Send Test Email" ok-title="Close" ok-only>
                <input class="form-control" type="email" required name="test_email" value="" v-model="email" placeholder="Please enter your email">
                <b-button class=" btn-sm mt-1 btn-success" @click="sendTestEmail"> Send Email</b-button>
            </b-modal>
        </div>
        <vue-snotify></vue-snotify>

        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Email Marketing Management</h4>
                    </div>
                    <div class="card-body">
                        <form action="" @submit.prevent="saveAsDraftEmail" method="post">
                            <div class="row">
                                <div class="col-md-4 col-sm-6">
                                    <div role="group" class="form-group">
                                        <label for="ContentType" class="d-block">Content Type</label>
                                        <div>
                                            <select class="custom-select" id="ContentType" v-model="contentData.ContentType"
                                                required name="ContentType">
                                                <option value="Email">Email</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6">
                                    <div role="group" class="form-group">
                                        <label for="GroupID" class="d-block">Group</label>
                                        <div>
                                            <select class="custom-select" @change="userSecShowFun" id="GroupID"
                                                v-model="contentData.GroupID" required name="GroupID">
                                                <option value="">Select Group</option>
                                                <option value="1">Futures1</option>
                                                <option value="2">Futures2</option>
                                                <option value="3">Currents</option>
                                                <option value="4">Pasts</option>
                                                <option value="5">Custom</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6" v-show="userSecShow">
                                    <div role="group" class="form-group">
                                        <label for="GroupID" class="d-block">Group</label>
                                        <div>
                                            <multiselect :multiple="true" v-model="multiUserDropdown.userDataList"
                                                :custom-label="nameLastName" :loading="multiUserDropdown.isLoading"
                                                @search-change="searchUserDropdown" track-by="UserID"
                                                :options="multiUserDropdown.options" @input="userIdPushFN">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6" v-show="!userSecShow">
                                    <div role="group" class="form-group">
                                        <label for="userNum" class="d-block">Enter Number of users</label>
                                        <div>
                                            <input id="userNum" type="text" v-model="contentData.number_of_users"
                                                placeholder="Enter number of users" class="form-control form-control-sm">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- </form> -->

                            <div class="landing-body">
                                <div class="landing-btn text-center p-3  border  d-flex justify-content-around">
                                    <a href="javascript:void(0)" class="btn btn-primary btn-sm" @click="redirectToViewTemplate">View Template</a>

                                    <a href="javascript:void(0)" class="btn btn-primary btn-sm" v-b-modal.modal-1>Send Test
                                        Email</a>
                                </div>
                                <div class="landing-form p-3 border mt-3">
                                    <!-- <form @submit.prevent="updateOrSaveLandingPage" method="post"> -->
                                    <div role="group" class="form-group">
                                        <label for="subject" class="d-block">Subject</label>
                                        <div>
                                            <input id="subject" name="subject" type="text" placeholder="subject"
                                                class="form-control form-control-sm" required
                                                v-model="contentResData.Subject">
                                        </div>
                                    </div>
                                    <div role="group" class="form-group">
                                        <label for="salutation" class="d-block">Salutation</label>
                                        <div>
                                            <input id="salutation" name="salutation" type="text"
                                                v-model="contentResData.Salutation" required placeholder="Salutation"
                                                class="form-control form-control-sm">
                                        </div>
                                    </div>
                                    <div role="group" class="form-group">
                                        <label for="TextBox1" class="d-block">Description 1</label>
                                        <div>

                                            <ckeditor id="TextBox1" v-model="contentResData.TextBox1" :config="editorConfig"
                                            >
                                            </ckeditor>
                                        </div>
                                    </div>
                                    <div role="group" class="form-group">
                                        <label for="TextBox2" class="d-block">Description 2</label>
                                        <div>
                                            <ckeditor id="TextBox2" v-model="contentResData.TextBox2" :config="editorConfig1"
                                            >
                                            </ckeditor>
                                        </div>
                                    </div>

                                    <div role="group" class="form-group">
                                        <div class="checkbox d-flex justify-content-between align-items-center flex-wrap flex-wrap-btn">
                                            <input type="button" class="btn btn-success m-1 btn-sm" @click="setSchedulerFN"
                                                value="Set Scheduler">
                                            <input type="submit" class="btn btn-success m-1 btn-sm" value="Save as draft">
                                            <input type="button" @click="sendTestEmail" class="btn btn-success m-1 btn-sm"
                                                value="Send Email">
                                        </div>
                                    </div>
                                    <!-- </form> -->

                                    <div class="scheduler" v-show="setScheduler">
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div role="group" class="form-group"><label for="sendingDate"
                                                        class="d-block">Days between sending </label>
                                                    <div>
                                                        <select class="custom-select" v-model="contentResData.DAYSBTWNEM">
                                                            <option value="daily" selected>Daily</option>
                                                            <option value="weekly">Weekly</option>
                                                            <option value="monthly">Monthly</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div>
                                                    <label for="SendTime">Send Time</label>&nbsp;&nbsp;
                                                    <input type="time" v-model="contentResData.SendTime" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div role="group" class="form-group"> <label>Action</label>
                                                    <div>
                                                        <select class="custom-select"
                                                            v-model="contentResData.SchedulerStatus" name="SchedulerStatus">
                                                            <option value="update" selected="">Create</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div role="group" class="form-group">
                                                    <label for="sendingDate" class="d-block">Start Date</label>
                                                    <div>
                                                        <input id="sendingDate" v-model="contentResData.StartDate"
                                                            type="date" class="form-control">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div role="group" class="form-group">
                                                    <label for="sendingDate" class="d-block">Stop Date</label>
                                                    <div>
                                                        <input id="sendingDate" type="date"
                                                            v-model="contentResData.StopDate" class="form-control">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4 pt-3">
                                                <input type="submit" value="Add Scheduler" class="btn btn-primary">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </div>

    </section>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import Vue from "vue";
import API from '@/api';
import CKEditor from 'ckeditor4-vue';
import Multiselect from 'vue-multiselect'
import moment from "moment"

Vue.use(CKEditor);

export default {
    name: 'landing_page',
    data() {
        return {
            time: '',
            email: "",
            multiUserDropdown: {
                options: [],
                isLoading: false,
                searchTerm: "",
                userDataList: []
            },
            editorConfig: { 
                versionCheck: false 
            },
            editorConfig1: { 
                versionCheck: false 
            },   
            userSecShow: false,
            setScheduler: false,
            contentData: {
                ContentType: "Email",
                GroupID: "",
                number_of_users: 0,
                selected_users_d: [],
                is_draft: true,
                IsEM: true
            },
            contentResData: {
                TextBox1: " ",
                TextBox2: `
                <p style="text-align: center; 
                    margin-top:8px; 
                    margin-bottom:5pt">We&#39;ll send you <span style="font-size:12pt; 
                    font-weight:bold; 
                    color:#bd2672">FREE</span> information, that you can use immediately.</p>

                    <div style="background-color: blue; margin:auto; margin-bottom:20px; width: 40%; height: 1px;">&nbsp;</div>

                    <p style="font-family:Arial, Helvetica, sans-serif;
                    font-size:16px; 
                    font-weight:bold; 
                    text-align:center;
                    color:#0d27c8; 
                    text-shadow: 1px 1px 1px #828282; 
                    background-color:#fdf5c6; 
                    border-collapse:collapse; 
                    border-style:solid;
                    line-height: 110%; 
                    margin:auto; 
                    box-sizing:border-box; 
                    box-shadow: 0px 10px 13px -7px #000000, 2px 2px 5px 2px rgba(0,0,0,0);
                    width:600px; 
                    border: 2px solid blue; 
                    padding:6px">Our weekly, one-hour Webinars are <span style="font-size:14pt; font-weight:bold; color:#bd2672">FREE</span>.&nbsp;&nbsp; <a href="http://www.dctrainings.com/Webinars.cfm" target="_blank"> <span style="font-size:14pt; 
                    font-weight:bold; 
                    font-family:calibri;
                    text-decoration:underline">Register</span></a> today!</p>

                    <p style="text-align: center; margin-top:20pt; line-height: 120%;">During our <span style="font-size:12pt; font-weight:bold; color:#bd2672">FREE</span> weekly <a href="https://www.dctrainings.com/Webinars.cfm" target="_blank"><span style="font-weight:bold; text-decoration:underline">Webinars</span></a>, our live <a href="https://www.dctrainings.com/seminars.cfm" target="_blank"><span style="font-weight:bold; text-decoration:underline">Seminars</span></a>, and online <a href="https://www.dctrainings.com/materials3.cfm" target="_blank"><span style="font-weight:bold; text-decoration:underline">Videos</span></a>,</p>

                    <p style="text-align: 
                    center; margin-top:3px; 
                    margin-bottom:20px">Dr. Sawyer explains how <span style="color:#2980b9; 
                    font-size:16px; 
                    font-weight:bold">DC Trainings</span> can help you <span style="font-weight:bold">Market</span> your practice.</p>

                    <p style="text-align:center; 
                    font-size:20px; 
                    font-weight:bold; 
                    color:#0d27c8;
                    background-color:#ebebeb; 
                    border-collapse:collapse; 
                    border-style:solid; 
                    margin:auto;
                    border-color:#666;
                    border-width:thin;
                    box-sizing:border-box; 
                    width:400px; 
                    padding:8px;">Call us today: (831) 588-3736</p>

                    <p style="text-align: center; margin-top:15pt"><a href="https://www.dctrainings.com" target="_blank"><span style="font-size:12pt; 
                    font-weight:bold; 
                    text-decoration:underline">Visit</span></a> our other <span style="font-weight:bold">Marketing</span> resources.</p>

                    <p style="text-align: center; 
                    font-size:16pt; 
                    font-weight:bold; 
                    font-family:calibri; 
                    color:#2980b9; 
                    margin-top:25px">Decide. Commit. Succeed!</p>
                `,
                Subject: "",
                Salutation: "",
                DAYSBTWNEM: 'daily',
                SendTime: "",
                SchedulerStatus: 'update',
                StopDate: "",
                StartDate: ''
            },
        }
    },
    methods: {
        // dropdown data lsit functionality
        nameLastName({ FirstName, LastName }) {
            return `${FirstName}  ${LastName}`
        },
        searchUserDropdown(query) {
            this.isLoading = true
            this.multiUserDropdown.searchTerm = query;
            clearTimeout(this.time)
            this.time = setTimeout(() => {
                this.getUserForDropdownList();
                this.isLoading = false
            }, 500);
        },
        userIdPushFN() {
            this.contentData.selected_users_d = this.multiUserDropdown.userDataList.map((data) => {
                return data.UserID;
            });
            console.log(this.contentData.selected_users_d);
        },
        getUserForDropdownList() {
            API.getUserForDropdownList({ search_term: this.multiUserDropdown.searchTerm }, this.getUserForDropdownListCB, this.errorCB);
        },
        getUserForDropdownListCB(res) {
            this.multiUserDropdown.options = res.data
            console.log(this.multiUserDropdown.options);
        },
        setSchedulerFN() {
            this.setScheduler = this.setScheduler == true ? false : true
        },
        userSecShowFun() {
            this.multiUserDropdown.userDataList = [];
            this.contentData.selected_users_d = [];
            if (this.contentData.GroupID == 5) {
                this.getUserForDropdownList();
                this.userSecShow = true;
            } else {
                this.userSecShow = false;
            }
        },

        // XX Dropdown list data functionality XX

        sendEmail() {
            let sendData = { ...this.contentData, ...this.contentResData }
            // console.log(sendData);
        },
        saveAsDraftEmail() {
            alert(this.contentResData.SendTime)
            if (this.contentResData.SendTime == '' && this.setScheduler == true) {
                this.$showNotification({ message: 'Please Select a time' }, "error")
            } else {
                let SendTimeCheck = moment(this.contentResData.SendTime, 'hh:mm A').format('HH:mm');
                let StopDate = new Date(this.contentResData.StopDate + "T" + SendTimeCheck);
                let StartDate = new Date(this.contentResData.StartDate + "T" + SendTimeCheck);
                if (StartDate > StopDate) {
                    this.$showNotification({ message: 'Stop Date Must be greater then Start Date' }, "error");
                } else {
                    this.contentResData.StartDate = moment(this.contentResData.StartDate).format('MM/DD/Y');
                    this.contentResData.StopDate = moment(this.contentResData.StopDate).format('MM/DD/Y'); 
                    this.contentResData.SendTime = moment.utc(this.contentResData.SendTime, 'hh:mm').format('hh:mm A');
                    let sendData = { ...this.contentData, ...this.contentResData }
                    API.saveAsDraftEmail(sendData, this.$showNotification({ message: 'data added successfully' }, "success"), this.errorCB)
                }
            }
        },
        errorCB(err) {
            console.log(err);
            this.$showNotification({ message: 'Failed system error' }, "error")
        },
        redirectToViewTemplate() {
            this.$router.push({
                name: 'viewEmailTemplate', 
                params: { data: this.contentResData } 
            });
        },
        sendTestEmailCB(res) {
            this.$showNotification(res, "success")
            this.$refs.modalRef.hide();
        },
        sendTestEmail () {
            API.sendTestEmail({
                email: this.email,
                Subject: this.contentResData.Subject,
                Salutation: this.contentResData.Salutation,
                TextBox1: this.contentResData.TextBox1,
                TextBox2: this.contentResData.TextBox2,

            }, this.sendTestEmailCB, this.errorCB);
        }
    },
    mounted() {
        API.get
    },
    components: { Multiselect },
}
</script>

<style>

@media (max-width: 450px) {
    .flex-wrap-btn {
        justify-content: center !important;
    }
}

</style>

